// old base code 

// import React, { useState } from "react";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { SECURITY_KEY } from "../../../globals";

// function AddGroupMaster() {
//   const [groupCode, setGroupCode] = useState("");
//   const [groupName, setGroupName] = useState("");
//   const [mainGroup, setMainGroup] = useState("");
//   const [level, setLevel] = useState("");
//   const [subGroup, setSubGroup] = useState("");
//   const [loading, setLoading] = useState(false);
  

//   const navigate = useNavigate();

//   // ✅ Add Group
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!groupCode || !groupName) {
//       toast.warning("Group Code and Group Name are required.");
//       return;
//     }

//     const payload = {
//       GroupCODE: groupCode,
//       GroupNAME: groupName,
//       MAINGroup: mainGroup,
//       Lavel: level,
//       SubGroup: subGroup,
//     };

//     const data = new URLSearchParams();
//     data.append("SecurityKey", SECURITY_KEY); // Using global variable instead of hardcoded value
//     data.append("TableName", "Group_mast");
//     data.append("*", "*");
//     data.append("WhereCondition", "All");
  

//     try {
//       setLoading(true);
//       await axios.post("http://localhost:5000/api/groups/create", payload);

//       toast.success("✅ Group added successfully!");

//       // ✅ Reset form
//       setGroupCode("");
//       setGroupName("");
//       setMainGroup("");
//       setLevel("");
//       setSubGroup("");

//       // ✅ Redirect after 2 seconds
//       setTimeout(() => {
//         navigate("/GroupMaster");
//       }, 2000);
//     } catch (err) {
//       console.error(err);
//       toast.error("❌ Failed to add group");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-center" autoClose={2000} />

//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Add New Group</h5>

//         <div className="compney_input_div">
//           <label className="mb-2">Group Code</label>
//           <input
//             type="text"
//             placeholder="Enter Group Code"
//             required
//             value={groupCode}
//             onChange={(e) => setGroupCode(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Group Name</label>
//           <input
//             type="text"
//             placeholder="Enter Group Name"
//             required
//             value={groupName}
//             onChange={(e) => setGroupName(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Main Group</label>
//           <input
//             type="text"
//             placeholder="Enter Main Group"
//             value={mainGroup}
//             onChange={(e) => setMainGroup(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Level</label>
//           <input
//             type="number"
//             placeholder="Enter Level"
//             value={level}
//             onChange={(e) => setLevel(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Sub Group</label>
//           <input
//             type="text"
//             placeholder="Enter Sub Group"
//             value={subGroup}
//             onChange={(e) => setSubGroup(e.target.value)}
//           />
//         </div>

//         <button type="submit" disabled={loading}>
//           {loading ? "Saving..." : "Save Group"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default AddGroupMaster;





// New Updated code 


import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

function AddGroupMaster() {
  const [groupName, setGroupName] = useState("");
  const [mainGroupCode, setMainGroupCode] = useState("");
  const [mainGroupName, setMainGroupName] = useState("");
  const [mainGroups, setMainGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // Fetch all main groups for dropdown
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(
          `${BASE_API_URL}/groups?page=1&limit=1000`
        );
        setMainGroups(res.data.data || []);
      } catch (err) {
        console.error("❌ Error fetching groups:", err);
        showToast.error("Failed to load groups");
      }
    };
    fetchGroups();
  }, [BASE_API_URL]);

  // Handle dropdown change
  const handleMainGroupChange = (e) => {
    const selectedCode = e.target.value;
    const selectedGroup = mainGroups.find(
      (grp) => grp.GroupCODE.toString() === selectedCode
    );
    setMainGroupCode(selectedCode);
    setMainGroupName(selectedGroup ? selectedGroup.GroupNAME : "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!groupName || !mainGroupCode) {
      showToast.warn("Group Name and Under Group are required.");
      return;
    }

    const payload = {
      GroupNAME: groupName,
      MAINGroup: mainGroupCode,
    };

    try {
      setLoading(true);

      await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/groups/create`,
        data: payload,
        module: "GroupMaster",
        action: "A",
      });

      showToast.save("Group added successfully!");

      setGroupName("");
      setMainGroupCode("");
      setMainGroupName("");

      setTimeout(() => {
        navigate("/GroupMaster");
      }, 1200);
    } catch (err) {
      console.error(err);
      showToast.error("Failed to add group");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Add Group Master</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/GroupMaster">Group Master</Link>
            <span>/</span>
            <span>New</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Group Details</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            {/* Group Name */}
            <div className="update_ledger_field">
              <label htmlFor="groupName">
                Group Name <span className="required">*</span>
              </label>
              <input
                id="groupName"
                type="text"
                placeholder="Enter Group Name"
                required
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </div>

            {/* Under Group (Dropdown) */}
            <div className="update_ledger_field">
              <label htmlFor="mainGroupCode">
                Under Group <span className="required">*</span>
              </label>
              <select
                id="mainGroupCode"
                value={mainGroupCode}
                onChange={handleMainGroupChange}
                required
              >
                <option value="">-- Select Under Group --</option>
                {mainGroups
                  .slice()
                  .sort((a, b) => a.GroupNAME.localeCompare(b.GroupNAME))
                  .map((grp) => (
                    <option key={grp.GroupCODE} value={grp.GroupCODE}>
                      {grp.GroupNAME}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/GroupMaster" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "+ Save Group"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddGroupMaster;
